import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-transfer-failure-icon',
    templateUrl: './transfer-failure-icon.component.html',
    styleUrls: ['./transfer-failure-icon.component.scss'],
    standalone: false
})
export class TransferFailureIconComponent implements OnInit {
  @Input() imageSrc!: string;
  @Input() imageWidth!: number;
  @Input() imageHeight!: number;

  constructor() {}

  ngOnInit() {
    this.imageSrc = '../../../../assets/Icons/transfer-error-icon-200x200.png';
  }
}
